<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import {ref, onMounted, onBeforeUnmount} from "vue";
import IconX from "@js/components/Icons/IconX.vue";
import IconFilter from "@js/components/Icons/IconFilter.vue";
import CatalogSelectedFilterTags from "@js/components/Sections/Catalog/CatalogSelectedFilterTags.vue";
import IconTrash from "@js/components/Icons/IconTrash.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "CatalogMobileFixedTopBar",
    components: {OnlyMobile, IconTrash, CatalogSelectedFilterTags, IconFilter, IconX, Link},
    setup() {
        const catalogStore = useCatalogStore();
        const isSticky = ref(false); // Флаг для фиксирования секции

        const handleScroll = () => {
            const scrollY = window.scrollY;
            isSticky.value = scrollY > 1; // Начинаем фиксировать, если прокрутка больше 52px
        };

        onMounted(() => {
            window.addEventListener("scroll", handleScroll);
        });

        onBeforeUnmount(() => {
            window.removeEventListener("scroll", handleScroll);
        });

        return {catalogStore, isSticky};
    },
};
</script>

<template>
    <section class="fixed bg-white border-b border-gray-300 shadow-sm z-2 w-full pe-0 transition-all"
             :class="[isSticky ? ' top-0' : 'top-[65px]']">
        <div class="bg-white px-[15px] py-[5px]">
            <div class="flex items-center">
                <div class="py-1">
                    <button type="button" @click.prevent="catalogStore.toggleFilter"
                            class="group inline-flex justify-center items-center text-white border-2 active:bg-transparent active:text-indigo-600 border-indigo-600 bg-indigo-600 font-medium rounded-full text-sm px-[12px] py-[6px] focus:outline-none transition">
                        <IconFilter class="w-4 h-4 me-2 group-active:text-indigo-600"/>
                        <span class="text-xs font-semibold text-nowrap">
                            Фильтр
                            <template v-if="catalogStore.selected_filters.length > 0">
                                ({{ catalogStore.selected_filters.length }})
                            </template>
                        </span>
                    </button>
                </div>
                <div class="ms-3">
                    <div class="vertical-divider"></div>
                </div>
                <div class="flex items-center overflow-x-auto ms-1" v-if="catalogStore.selected_filters.length > 0">
                    <CatalogSelectedFilterTags/>
                </div>
                <OnlyMobile v-else>
                    <Link :href="route('catalog', {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['2p30'])
                                    })"
                          class="text-white border-2 border-indigo-600 bg-indigo-600 rounded-full px-[12px] py-[6px] focus:outline-none ms-3 text-xs font-semibold text-nowrap">
                        Посмотреть рекомендации
                    </Link>
                </OnlyMobile>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.z-2 {
    z-index: 2;
}
</style>
